import type { ModalTypes } from '@ir/client/views/modal/RootModal';
import { makeAutoObservable } from 'mobx';

export class ModalState {
  modalType: null | ModalTypes = null;
  modalProps: object = {};
  constructor() {
    makeAutoObservable(this);
  }
  hideModal = () => {
    this.modalType = null;
    this.modalProps = {};
  };

  showModal(type: ModalTypes, props?: any) {
    this.modalType = type;
    this.modalProps = props;
  }

  updateModal(props: object) {
    this.modalProps = props;
  }
}
